export default __webpack_public_path__ + "static/media/design_icon.ea5b9f8f.svg";